import type { NotificationsMessages } from "./messages.en";

export const notificationsNavEs: Partial<Record<keyof NotificationsMessages, string>> = {
  "notifications.nav.outbox": "Bandeja de salida de avisos",
  "notifications.nav.templates": "Plantillas de mensajes",
  // Shown by the invitation and statement dialogs too, before this module's screens load.
  "notifications.emailPreview.to": "Para",
  "notifications.emailPreview.subject": "Asunto",
  "notifications.emailPreview.attachment": "Adjunto",
  "notifications.emailPreview.noAddress": "Sin dirección",
  "notifications.emailPreview.label": "El correo tal como se enviará",
  "notifications.bell.label": "Avisos",
};

export const notificationsEs: Partial<Record<keyof NotificationsMessages, string>> = {
  "notifications.inbox.title": "Avisos",
  "notifications.inbox.subtitle": "Lo que ClubCore le ha avisado en este club, lo más reciente primero.",
  "notifications.inbox.unreadOnly": "Solo sin leer",
  "notifications.inbox.markAll": "Marcar todo como leído",
  "notifications.inbox.markRead": "Marcar como leído",
  "notifications.inbox.markReadOf": "Marcar «{title}» como leído",
  "notifications.inbox.open": "Abrir",
  "notifications.inbox.openOf": "Abrir «{title}»",
  "notifications.inbox.unread": "Sin leer",
  "notifications.inbox.settings": "Ajustes de avisos",
  "notifications.inbox.marked_one": "{count} aviso marcado como leído",
  "notifications.inbox.marked_other": "{count} avisos marcados como leídos",
  "notifications.inbox.empty": "Todavía no hay nada",
  "notifications.inbox.emptyBody": "Cuando algo requiera su atención, como una nueva solicitud de un socio, aparecerá aquí.",
  "notifications.inbox.emptyUnread": "No hay avisos sin leer",

  "notifications.settings.title": "Ajustes de avisos",
  "notifications.settings.subtitle": "Elija cómo quiere enterarse de cada tema. La campana siempre lo muestra todo.",
  "notifications.settings.topic": "Tema",
  "notifications.settings.urgent": "Se envía incluso en horas de silencio",
  "notifications.settings.choice.default": "Lo que decida el club ({state})",
  "notifications.settings.choice.on": "Sí",
  "notifications.settings.choice.off": "No",
  "notifications.settings.state.on": "sí",
  "notifications.settings.state.off": "no",
  "notifications.settings.cell": "{topic}: {channel}",
  "notifications.settings.quiet": "Horas de silencio",
  "notifications.settings.quietHint": "Los mensajes de texto y los avisos de la aplicación esperan a que terminen las horas de silencio. El correo y la campana no se retienen.",
  "notifications.settings.quiet.club": "Las del club (de {start} a {end})",
  "notifications.settings.quiet.clubNone": "Las del club (no tiene)",
  "notifications.settings.quiet.own": "Mis propias horas",
  "notifications.settings.quiet.off": "Sin horas de silencio",
  "notifications.settings.quietMode": "Horas de silencio",
  "notifications.settings.quietStart": "Desde",
  "notifications.settings.quietEnd": "Hasta",
  "notifications.settings.language": "Idioma de los avisos",
  "notifications.settings.language.club": "El idioma del club",
  "notifications.settings.language.en": "Inglés",
  "notifications.settings.language.es": "Español",
  "notifications.settings.timezone": "Zona horaria",
  "notifications.settings.timezoneHint": "Déjela vacía para usar la del club ({zone}).",
  "notifications.settings.save": "Guardar",
  "notifications.settings.saved": "Ajustes de avisos guardados",
  "notifications.settings.nothingToChoose": "Todavía no se envía ningún tema del personal por correo ni por texto.",

  "notifications.channel.email": "Correo",
  "notifications.channel.text": "Texto",
  "notifications.channel.push": "Aplicación",
  "notifications.channel.voice": "Llamada",
  "notifications.channel.in_app": "Campana o bandeja",

  "notifications.topic.tee_time_confirmation": "Confirmación de hora de salida",
  "notifications.topic.tee_time_reminder": "Recordatorio de hora de salida",
  "notifications.topic.statement_ready": "Estado de cuenta disponible",
  "notifications.topic.bill_due": "Vencimiento de pago",
  "notifications.topic.guest_arrival_staff": "Llegada de invitados",
  "notifications.topic.weather_closure": "Clima y cierre del campo",
  "notifications.topic.service_request_update": "Respuestas a solicitudes de socios",
  "notifications.topic.lodging_request_update": "Respuestas a solicitudes de estancia",
  "notifications.topic.member_request_staff": "Nuevas solicitudes de socios",
  "notifications.topic.tee_time_cancelled": "Hora de salida cancelada",
  "notifications.topic.event_signup_update": "Actualizaciones de inscripción a eventos",
  "notifications.topic.dining_reservation_update": "Respuestas a reservas de comedor",
  "notifications.topic.dining_reservation_staff": "Solicitudes de comedor",

  "notifications.unavailable.email_configured": "El envío de correo aún no está activado",
  "notifications.unavailable.email_off": "El club no envía correos",
  "notifications.unavailable.email_incomplete": "Los ajustes de correo del club están incompletos",
  "notifications.unavailable.email_insecure": "Los ajustes de correo del club no son seguros",
  "notifications.unavailable.sms_not_available": "Los mensajes de texto aún no están disponibles",
  "notifications.unavailable.not_configured": "La centralita no está preparada para mensajes de texto",
  "notifications.unavailable.no_sms_number": "El club no tiene número para mensajes de texto",
  "notifications.unavailable.push_not_set_up": "La aplicación aún no está disponible",
  "notifications.unavailable.other": "Aún no disponible",

  "notifications.outbox.title": "Bandeja de salida de avisos",
  "notifications.outbox.subtitle": "Correos y mensajes de texto que salen del club, y por qué alguno espera. Aquí no se muestra lo que dice cada mensaje.",
  "notifications.outbox.held_one": "{count} correo está retenido porque el envío de correo no está activado. Saldrá cuando se active el correo en Ajustes del club > Comunicaciones, si aún es reciente.",
  "notifications.outbox.held_other": "{count} correos están retenidos porque el envío de correo no está activado. Saldrán cuando se active el correo en Ajustes del club > Comunicaciones, si aún son recientes.",
  "notifications.outbox.status": "Estado",
  "notifications.outbox.allStatuses": "Todos los estados",
  "notifications.outbox.channel": "Canal",
  "notifications.outbox.allChannels": "Correo y texto",
  "notifications.outbox.col.created": "Creado",
  "notifications.outbox.col.topic": "Tema",
  "notifications.outbox.col.recipient": "Para",
  "notifications.outbox.col.channel": "Canal",
  "notifications.outbox.col.status": "Estado",
  "notifications.outbox.col.attempts": "Intentos",
  "notifications.outbox.col.actions": "Acciones",
  "notifications.outbox.nextTry": "Próximo: {time}",
  "notifications.outbox.retry": "Reintentar",
  "notifications.outbox.retryOf": "Reintentar el mensaje para {name}",
  "notifications.outbox.cancel": "Cancelar",
  "notifications.outbox.cancelOf": "Cancelar el mensaje para {name}",
  "notifications.outbox.retried": "El mensaje se ha vuelto a poner en cola",
  "notifications.outbox.cancelled": "El mensaje se ha cancelado",
  "notifications.outbox.empty": "Todavía no se ha enviado nada",
  "notifications.outbox.emptyFiltered": "Ningún mensaje coincide con estos filtros",
  "notifications.outbox.someone": "Alguien",

  "notifications.status.pending": "Pendiente de envío",
  "notifications.status.scheduled": "Programado",
  "notifications.status.held": "Retenido",
  "notifications.status.sending": "Enviando",
  "notifications.status.sent": "Enviado",
  "notifications.status.delivered": "Entregado",
  "notifications.status.failed": "Fallido",
  "notifications.status.suppressed": "Bloqueado",
  "notifications.status.skipped": "Omitido",
  "notifications.status.expired": "Caducado",
  "notifications.status.cancelled": "Cancelado",

  "notifications.reason.email_configured": "correo no activado",
  "notifications.reason.email_off": "correo desactivado",
  "notifications.reason.email_incomplete": "ajustes de correo incompletos",
  "notifications.reason.sms_not_available": "texto aún no disponible",
  "notifications.reason.no_sms_number": "sin número para texto",
  "notifications.reason.not_configured": "centralita sin configurar",
  "notifications.reason.quiet_hours": "horas de silencio",
  "notifications.reason.rate_limited": "límite por hora alcanzado",
  "notifications.reason.retrying": "se volverá a intentar",
  "notifications.reason.no_address": "sin dirección registrada",
  "notifications.reason.bounce": "dirección rechazada antes",
  "notifications.reason.opted_out": "respondió STOP",
  "notifications.reason.recipient_refused": "el servidor de correo rechazó la dirección",
  "notifications.reason.gave_up": "abandonado tras 6 intentos",
  "notifications.reason.outcome_unknown": "no se sabe si se envió",
  "notifications.topic.phone_message_staff": "Nuevos mensajes telefónicos (al personal)",
  "notifications.topic.account_invite": "Invitación de socio",
  "notifications.topic.account_magic_link": "Enlace de acceso",
  "notifications.topic.account_password_reset": "Restablecer contraseña",
  "notifications.topic.account_pin_reset": "Restablecer PIN",
  "notifications.topic.account_step_up": "Confirme que es usted",
  "notifications.topic.statement_email": "Correo del estado de cuenta",

  "notifications.templates.title": "Plantillas de mensajes",
  "notifications.templates.subtitle": "Lea y cambie el texto de todo lo que ClubCore envía para este club, en inglés y en español. Los mensajes que ya esperan conservan el texto con el que se crearon.",
  "notifications.templates.group": "Mensajes",
  "notifications.templates.group.all": "Todos los mensajes",
  "notifications.templates.group.notification": "Avisos",
  "notifications.templates.group.account": "Correos de la cuenta de socio",
  "notifications.templates.group.statement": "Correo del estado de cuenta",
  "notifications.templates.language": "Idioma",
  "notifications.templates.language.en": "Inglés",
  "notifications.templates.language.es": "Español",
  "notifications.templates.table": "Plantillas de mensajes",
  "notifications.templates.col.message": "Mensaje",
  "notifications.templates.col.channel": "Enviado por",
  "notifications.templates.col.subject": "Asunto o título",
  "notifications.templates.col.wording": "Texto",
  "notifications.templates.col.action": "Cambiar",
  "notifications.templates.builtin": "Predeterminado",
  "notifications.templates.custom": "Del club",
  "notifications.templates.edit": "Editar",
  "notifications.templates.editOf": "Editar {message} ({channel})",
  "notifications.templates.editTitle": "{message}: {channel}, {language}",
  "notifications.templates.editBody": "Escriba el texto y ponga una variable donde ClubCore completa un valor para cada persona.",
  "notifications.templates.subject": "Asunto",
  "notifications.templates.titleField": "Título",
  "notifications.templates.body": "Mensaje",
  "notifications.templates.variables": "Variables",
  "notifications.templates.variablesHint": "Elija una para ponerla donde está el cursor.",
  "notifications.templates.insert": "Insertar {name}",
  "notifications.templates.required": "Conserve {names}: el mensaje no funciona sin ello.",
  "notifications.templates.preview": "Vista previa con valores de ejemplo",
  "notifications.templates.previewing": "Actualizando la vista previa…",
  "notifications.templates.problems": "Corrija esto antes de guardar",
  "notifications.templates.save": "Guardar texto",
  "notifications.templates.saved": "Texto guardado",
  "notifications.templates.reset": "Volver al texto predeterminado",
  "notifications.templates.resetDone": "Texto predeterminado restablecido",
  "notifications.templates.empty": "Ningún mensaje coincide",

};
